import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function Terms() {
  return (
    <div className="min-h-screen bg-qc-bg text-qc-text">
      <div 
        className="px-5 py-3 flex items-center max-w-2xl mx-auto"
        style={{ paddingTop: 'max(0.75rem, env(safe-area-inset-top, 0px))' }}
      >
        <Link
          to="/login"
          data-testid="terms-back-button"
          className="w-10 h-10 flex items-center justify-center rounded-full bg-qc-surface border border-qc-border text-qc-text"
        >
          <ArrowLeft className="w-5 h-5" />
        </Link>
        <h1 className="text-base font-extrabold text-qc-text ml-3">Terms of Service</h1>
      </div>

      <div className="max-w-2xl mx-auto px-5 py-6" data-testid="terms-page">
        <h1 className="text-3xl font-black text-qc-text mb-6">Terms of Service</h1>
        
        <div className="prose prose-invert prose-sm max-w-none space-y-6 text-qc-text-dim">
          <p className="text-sm">
            <strong className="text-qc-text">Last updated:</strong> January 2025
          </p>

          <section>
            <h2 className="text-lg font-bold text-qc-text mb-2">1. Acceptance of Terms</h2>
            <p>
              By accessing or using Green Light (&ldquo;the Service&rdquo;), you agree to be bound by these Terms of Service. 
              If you do not agree to these terms, please do not use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-qc-text mb-2">2. Description of Service</h2>
            <p>
              Green Light provides AI-powered analysis of food products to help users make informed dietary decisions. 
              The Service offers verdicts (GO, MAYBE, HELL NO) based on product images and user health profiles.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-qc-text mb-2">3. Medical Disclaimer</h2>
            <p>
              Green Light is not a medical device and does not provide medical advice. The verdicts and suggestions 
              provided are for informational purposes only and should not replace professional medical guidance. 
              Always consult with a healthcare provider before making significant dietary changes.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-qc-text mb-2">4. User Accounts</h2>
            <p>
              You are responsible for maintaining the confidentiality of your account credentials and for all 
              activities that occur under your account. You must provide accurate information when creating an account.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-qc-text mb-2">5. Subscription and Billing</h2>
            <p>
              Green Light offers both free and paid subscription plans. Paid subscriptions automatically renew 
              unless cancelled before the renewal date. You can cancel your subscription at any time through 
              your account settings.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-qc-text mb-2">6. Acceptable Use</h2>
            <p>
              You agree not to misuse the Service, including but not limited to: attempting to access unauthorized 
              areas, interfering with other users, or using the Service for any illegal purposes.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-qc-text mb-2">7. Limitation of Liability</h2>
            <p>
              Green Light and its operators shall not be liable for any indirect, incidental, special, consequential, 
              or punitive damages resulting from your use of or inability to use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-qc-text mb-2">8. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Continued use of the Service after changes 
              constitutes acceptance of the new terms.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-qc-text mb-2">9. Contact</h2>
            <p>
              For questions about these Terms, please visit our <Link to="/contact" className="text-qc-green hover:text-qc-green-dark font-medium">Contact page</Link>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
